import { render, staticRenderFns } from "./campaignLevelPlate.vue?vue&type=template&id=035828d8&scoped=true&"
import script from "./campaignLevelPlate.vue?vue&type=script&lang=js&"
export * from "./campaignLevelPlate.vue?vue&type=script&lang=js&"
import style0 from "./campaignLevelPlate.vue?vue&type=style&index=0&id=035828d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035828d8",
  null
  
)

export default component.exports